import * as React from 'react';
var TriggerContext = /*#__PURE__*/React.createContext(null);
export default TriggerContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-trigger/es/context.js
// module id = 634
// module chunks = 0